import React from 'react';
import toast from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteInterview } from '../../../apis/app.service';

import AppButton from '../../sharedcomponents/Buttons/AppButton/AppButton';
import { useInterviewsPage } from '../../../store/InterviewsProvider';

export default function ConfirmInterviewDelete() {
  const { interview } = useInterviewsPage();
  const { data } = interview;

  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: deleteInterview,
    onSuccess: ({ message }) => {
      queryClient.invalidateQueries({
        queryKey: ['interviews'],
      });
      toast.success(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
    onError(error: Error) {
      const { message } = error;
      toast.error(message, {
        duration: 3000,
        position: 'top-right',
      });
    },
  });

  const handleDelete = (userId: string) => {
    mutation.mutate(userId);
  };

  return (
    <>
      <div
        className="modal fade"
        id="kt_modal_confirm_delete"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered mw-900px">
          <div className="modal-content">
            <div className="modal-header">
              <h2>Confirm Action</h2>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              Are you sure you want to delete <strong>{`${data.name}`}</strong>{' '}
              data?
            </div>
            <div className="modal-footer">
              <AppButton
                btnType="danger"
                onClick={() => handleDelete(data.id ?? '')}
                data-bs-dismiss="modal"
              >
                {!mutation.isPending && (
                  <span className="indicator-label">Delete</span>
                )}
                {mutation.isPending && (
                  <span
                    className="indicator-progress"
                    style={{ display: 'block' }}
                  >
                    Please wait...
                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  </span>
                )}
              </AppButton>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
